import {
 SUPER_ADMIN_ROUTE,
 SUPER_ADMIN_CLIENTS_ROUTE,
  SUPER_ADMIN_USERS_ROUTE
} from '../utils/Constants';

export const SuperAdminRoutes = () => {
    const routes = [
          SUPER_ADMIN_ROUTE,
          SUPER_ADMIN_CLIENTS_ROUTE,
          SUPER_ADMIN_USERS_ROUTE
      ]
    return routes;
  }
  